import { render, staticRenderFns } from "./NoteFormModal.vue?vue&type=template&id=30237b1a&"
import script from "./NoteFormModal.vue?vue&type=script&lang=js&"
export * from "./NoteFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports